import {
  FC,
  ReactNode,
  createContext,
  useCallback,
  useMemo,
  useState
} from 'react';
import type { Order } from 'src/API';

export type PageBranding = {
  title: string;
  image: string;
  email?: string;
};

export const PREPT_BASKET_LOGO = '/static/images/logo/prept-basket-logo.png';

/** @deprecated Use PREPT_BASKET_LOGO */
export const PREPT_SHOPPING_CART_ICON = PREPT_BASKET_LOGO;

export const DEFAULT_PAGE_BRANDING: PageBranding = {
  title: 'Resort Grocery',
  image: PREPT_BASKET_LOGO,
  email: ''
};

type PageBrandingContextValue = {
  branding: PageBranding;
  setPageBranding: (branding: PageBranding) => void;
  resetPageBranding: () => void;
};

export const PageBrandingContext = createContext<PageBrandingContextValue>(
  {} as PageBrandingContextValue
);

export function getOrderPageBranding(order: Order): PageBranding {
  const serviceRequest = order.serviceRequestList?.[0];

  return {
    title: serviceRequest?.serviceName || DEFAULT_PAGE_BRANDING.title,
    image: serviceRequest?.image || DEFAULT_PAGE_BRANDING.image,
    email: order.shopperInfo?.email || ''
  };
}

export const PageBrandingProvider: FC<{ children: ReactNode }> = ({
  children
}) => {
  const [branding, setBranding] = useState<PageBranding>(DEFAULT_PAGE_BRANDING);

  const setPageBranding = useCallback((nextBranding: PageBranding) => {
    setBranding(nextBranding);
  }, []);

  const resetPageBranding = useCallback(() => {
    setBranding(DEFAULT_PAGE_BRANDING);
  }, []);

  const value = useMemo(
    () => ({
      branding,
      setPageBranding,
      resetPageBranding
    }),
    [branding, setPageBranding, resetPageBranding]
  );

  return (
    <PageBrandingContext.Provider value={value}>
      {children}
    </PageBrandingContext.Provider>
  );
};

